import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { DynApp } from './DynApp';
import './global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <DynApp />
  </StrictMode>,
);
